const regex = /^[\w\-.!#$%&’*+/=?^_`{|}~-]+@([\w-]+\.)+[\w-]{2,}$/;

// Simple email validation
export const isEmailValid = (email: string) => {
  return regex.test(email);
};
